import React from 'react';

const Button = (props) => (
  <button type="button" className="btn btn-sm btn-block btn-light" {...props}>
    {props.children}
  </button>
)

export default Button;
